// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumb_breadcrumbs__S-5rD","bread_crumb_item":"breadcrumb_bread_crumb_item__2w1mk","active":"breadcrumb_active__2_v08"};